// src/utils/geocode.js
const LOCATIONIQ_TOKEN = process.env.REACT_APP_LOCATIONIQ_TOKEN;

// Nyers location string → geokódolásra alkalmas, letisztított cím
export function normalizeLocationForGeocoding(raw) {
  if (!raw) return "";
  let text = String(raw);

  // sortörések, dupla szóközök eltüntetése
  text = text.replace(/\s+/g, " ").trim();

  // elejéről leszedjük a "📍" + "Helyszín:" részt, ha van
  text = text.replace(/^📍\s*/u, "");
  text = text.replace(/^Helyszín\s*:\s*/i, ""); // Helyszín: ... eleje

  // tipikus "meta" részek levágása
  const stopWords = [
    "Finanszírozás:",
    "Finanszirozás:",
    "Programszervező:",
    "Program szervező:",
    "Ajánljuk:",
    "Kísérők:",
    "Jelentkezem",
    "Részletek",
  ];

  for (const marker of stopWords) {
    const idx = text.indexOf(marker);
    if (idx !== -1) {
      text = text.slice(0, idx).trim();
      break;
    }
  }

  // biztonság kedvéért ne legyen extrém hosszú
  if (text.length > 160) {
    text = text.slice(0, 160);
  }

  return text;
}

// LocationIQ geokódolás – mindenhol ezt érdemes hívni
export async function geocodeLocation(rawLocation) {
  const query = normalizeLocationForGeocoding(rawLocation);
  if (!query || !LOCATIONIQ_TOKEN) return null;

  const url = `https://eu1.locationiq.com/v1/search?key=${LOCATIONIQ_TOKEN}&q=${encodeURIComponent(
    query
  )}&format=json&limit=1`;

  const resp = await fetch(url);
  if (!resp.ok) {
    console.error("LocationIQ HTTP error", resp.status);
    return null;
  }

  const json = await resp.json();
  if (!Array.isArray(json) || json.length === 0) {
    return null;
  }

  const best = json[0];
  const lat = parseFloat(best.lat);
  const lng = parseFloat(best.lon);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    return null;
  }

  return {
    lat,
    lng,
    displayName: best.display_name,
    query, // mire geokódoltunk valójában
  };
}
